import {AppLayout} from "base/layout";
import {AppConfigProvider} from "base/provider";

import {MainFooter} from "../../main/layout/MainFooter";
import {MainHeaderHero} from "../../main/layout/MainHeaderHero";
import MainMenu from "../../main/menu/MainMenu";
import {MainAppProvider} from "../../main/provider/MainAppProvider";

export const MainApp = () => {
    return (
        <AppConfigProvider>
            <MainAppProvider>
                <AppLayout
                    hero={<MainHeaderHero />}
                    menu={<MainMenu />}
                    footer={<MainFooter />}
                />
            </MainAppProvider>
        </AppConfigProvider>
    );
};
